export default "__VITE_ASSET__a3465d55__"